module.exports = __webpack_public_path__ + "static/media/android_logo.e7b43863.jpg";